<template>
    <div class="content">
        <div class="title">
            智能家居
            <div class="line"></div>
        </div>
        <el-row class="hang">
            <el-col :span="8" class="lie">
                <img src="../../assets/img/3icon1.png" alt="">
                <a href="#"><span>智能电器控制</span></a>
            </el-col>
            <el-col :span="8" class="lie">
                <img src="../../assets/img/3icon3.png" alt="">
                <a href="#"><span>智能灯光设置</span></a>
            </el-col>
            <el-col :span="8" class="lie">
                <img src="../../assets/img/3icon2.png" alt="">
                <a href="#"><span>安防监控系统</span></a>
            </el-col>
            <el-col></el-col>
        </el-row>
    </div>
</template>

<script>
  export default {
    name: "SmartHome"
  }
</script>

<style scoped lang="less">
    .content {
        padding: 60px 170px;
        background: url(../../assets/img/page3bg.jpg) no-repeat;
        background-size: 100% 100%;
        height: 720px;
    }

    .title {
        padding-top: 20px;
        text-align: center;
        font-size: 34px;
        color: #595757;
    }

    .line {
        width: 103px;
        background: #e5d276;
        height: 4px;
        margin: 10px auto;
    }

    .hang {
        padding-top: 70px;
    }

    .lie {
        padding: 0 15px;

        > a {
            text-decoration: none;
            color: #333;

            > span {
                margin-left: 34px;
                font-size: 30px;
                color: #595757;
            }
        }
    }

</style>
